package org.dronda.app.web.ui.notfound

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import org.dronda.app.web.ui.components.StyledButton
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun NotFoundScreen(onNavigateHome: () -> Unit) {
    Column(
        modifier = Modifier.fillMaxSize()
            .padding(16.px),
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        H1(
            Modifier
                .fontWeight(FontWeight.Thin)
                .fontSize(3.cssRem)
                .padding(bottom = 16.px)
                .toAttrs()
        ) {
            Text("404")
        }

        P(
            Modifier
                .fontWeight(350)
                .fontSize(1.2.cssRem)
                .padding(bottom = 32.px)
                .toAttrs()
        ) {
            Text("Page not found")
        }

        StyledButton(
            "Go to Events",
            onClick = { onNavigateHome() },
            modifier = Modifier.minHeight(48.px)
        )
    }
}
